import React from "react";
import styled from "styled-components";
import CustomNetworkImage from "../image/CustomNetworkImage";
import { Column, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import ReactDOM from "react-dom";
import CustomText from "../text/CustomText";
import { Theme } from "../../Theme";

const PopupOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${Theme.color.black_05};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
`;

/**
 * 팝업 컴포넌트
 * @param {boolean} isOpen - 팝업 표시 여부
 * @param {function} onClose - 닫기(취소) 버튼 클릭 시 호출될 함수
 * @param {string} src - 이미지 url
 * @param {string} altText - 이미지 로드 불가시 노출 텍스트
 * @param {number} total - 총 이미지 수
 * @param {number} current - 현재 이미지 인덱스
 */
const MultiImagePopup = ({ isOpen, onClose, src, altText, total, current, onClickNext, onClickPrev }) => {
    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <PopupOverlay>
            <Column width={"100%"} height={"100%"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <Row width={"100%"} justifyContent={"flex-end"} padding={"40px 40px 20px 0"}>
                    <CustomIcon
                        iconName={"image_close_button"}
                        size={"40px"}
                        onClick={() => {
                            onClose();
                        }}
                        cursor={"pointer"}
                    />
                </Row>
                <Row width={"100%"} height={"75vh"} justifyContent={"center"} alignItems={"center"}>
                    <SizedBox
                        backgroundColor={Theme.color.gray500}
                        width={"auto"}
                        height={"auto"}
                        padding={"13px"}
                        borderRadius={"100%"}
                        cursor={"pointer"}
                        style={{ visibility: current === 1 ? "hidden" : "visible" }}
                        onClick={onClickPrev}
                    >
                        <CustomIcon
                            iconName={"prev_white"}
                            size={"18px"}
                            cursor={"pointer"}
                            style={{ visibility: current === 1 ? "hidden" : "visible" }}
                        />
                    </SizedBox>
                    <SizedBox width={"24px"} />
                    <CustomNetworkImage src={src} alt={altText} width={"70%"} height={"75vh"} borderRadius={"12px"} />
                    <SizedBox width={"24px"} />
                    <SizedBox
                        backgroundColor={Theme.color.gray500}
                        width={"auto"}
                        height={"auto"}
                        padding={"13px"}
                        borderRadius={"100%"}
                        cursor={"pointer"}
                        style={{ visibility: current === total ? "hidden" : "visible" }}
                        onClick={onClickNext}
                    >
                        <CustomIcon
                            iconName={"next_white"}
                            size={"18px"}
                            cursor={"pointer"}
                            style={{ visibility: current === total ? "hidden" : "visible" }}
                        />
                    </SizedBox>
                </Row>
                <SizedBox width={"100%"} height={"24px"} />
                <CustomText fontSize={"16px"} fontWeight={"400"} fontColor={Theme.color.neutral100}>
                    {current}/{total}
                </CustomText>
            </Column>
        </PopupOverlay>,
        document.getElementById("modal-root")
    );
};

export default MultiImagePopup;
